<section style="padding-bottom: 0px!important;">
  <h4>Premise address</h4>
  <app-select-premises title="premise" [item]="workExperience.premise"
    (selected)="workExperience.updatePremises($event)" [touched]="touched" [readonly]="readonly">
  </app-select-premises>
  @if (!!workExperience.premise) {
    <div class="pt-4">
      <div class="form-group" [class.invalid]="touched && !workExperience.jobTitleValid">
        <h4>Job description</h4>
        <div class="col-md-4 mb-4" style="margin-left:0;padding-left:0;">
          <label for="jobTitle">Job Title</label>
          <input  class="form-control" required type="text"  placeholder="Job title"
            [disabled]="readonly"
            [value]="workExperience.jobTitle"
            (change)="workExperience.updateJobTitle($event.target.value)"
            >
          </div>
        </div>
        <div class="col-md-4 mb-4" style="margin-left:0;padding-left:0;">
          <div class="form-group" [class.invalid]="touched && !workExperience.workingHoursValid">
            <label for="workingHours">Hours per week</label>
            <input matInput min="0"
              [disabled]="readonly"
              class="form-control" type="number" placeholder="Hours per week"
              [value]="workExperience.workedHoursPerWeek"
              (change)="workExperience.updateWorkingHours($event.target.value)">
            </div>
          </div>
        </div>
      }
    </section>

    <app-collapsible [trigger]="workExperience.premiseValid">
      <section class="form-group" [class.invalid]="touched && !workExperience.datesValid">
        <h4>Training dates</h4>

        <!-- [fromMin]="workExperience.trainingWindow?.start.from"
        [fromMax]="index === 0 ? workExperience.trainingWindow?.start.to : undefined" -->
        <app-daterange

          [fromDate]="workExperience.startDate" [toMax]="$safeNavigationMigration(workExperience.trainingWindow?.end.to)"
          [toDate]="workExperience.endDate" (changed)="workExperience.setDaterange($event)" [readonly]="readonly"
          [overlapError]="workExperience.overlap$ | async"
          overlapErrorMessage="Invalid start date - placement dates must not overlap"
          fromDateTooEarlyMessage="Start date is before the permitted application opening"
          fromDateTooLateMessage="Start date is after the permitted application close"
          toDateTooLateMessage="End date is after the current registration date limit">
        </app-daterange>

        @if (index === 0) {
          <div>
            <p class="important col-sm-6">
              Your first placement start date must be within the date range specified to meet the training scheme
              requirements.
            </p>
          </div>
        }

      </section>
    </app-collapsible>

    <app-collapsible [trigger]="workExperience.premiseValid && workExperience.datesValid">
      <section>
        <h4>Supervising pharmacist</h4>
        @for (supervisor of workExperience.supervisingPharmacists; track supervisor; let i = $index) {
          <div class="form-group">
            <app-select-registrant style="display:block;flex-grow:1" title="pharmacist" [item]="supervisor"
              (selected)="workExperience.updateSupervisor($event, i)" [touched]="touched" [readonly]="readonly"
              [trainingPlacementStartDate]="workExperience.startDate">
            </app-select-registrant>
          </div>
        }
      </section>
    </app-collapsible>